import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import PublicNav from "@/components/PublicNav";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Please try again shortly");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen">
      <PublicNav />
      <div className="max-w-md mx-auto p-8" data-testid="forgot-page">
        <div className="fx-panel p-8">
          <h1 className="font-display text-2xl font-bold text-white">Forgot your password?</h1>
          <p className="text-sm text-slate-400 mt-1">Enter your email and we will send a reset link.</p>
          {sent ? (
            <div className="mt-6 text-sm text-slate-200" data-testid="forgot-sent">
              If an account exists for <span className="text-cyan-300">{email}</span>, we just emailed a reset link. It expires in 1 hour and can only be used once.
              <div className="mt-4"><Link to="/login" className="text-cyan-300 hover:text-cyan-200 text-sm">Back to sign in</Link></div>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
              <label className="block">
                <div className="text-xs text-slate-400 mb-1">Email</div>
                <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#0D1224] border border-[#1E293B] rounded-lg px-3 py-2 text-sm text-slate-100 focus:border-cyan-400 outline-none" data-testid="forgot-email" />
              </label>
              <button disabled={busy} className="fx-btn-primary w-full text-white font-medium py-2.5 rounded-lg disabled:opacity-60" data-testid="forgot-submit">{busy ? "Sending…" : "Send reset link"}</button>
              <div className="text-center"><Link to="/login" className="text-slate-500 hover:text-slate-300 text-sm">Back to sign in</Link></div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
